import React from 'react';

const IconNorskTipping = ({ className, style, ...props }) => {
  return (
    <img 
      src="/icons/norsktipping.png" 
      alt="NorskTipping" 
      className={className}
      style={{ 
        width: '1.5em', 
        height: '1.5em', 
        objectFit: 'contain',
        ...style 
      }}
      {...props} 
    />
  );
};

export default IconNorskTipping;